import { useQuery } from 'react-query';
import Api from '../../../../shared/Api';

export function getPublicHolidays<T>(year: number, country: number) {
    return useQuery(['holidays', year], () =>
        new Api().get(`/views/photographer-calendars/holidays?country=${country}&year=${year}`)
    );
}
